// extracted by mini-css-extract-plugin
module.exports = {"root":"ElevatedBox_root___2Q4H","padding-base":"ElevatedBox_padding-base__lfYc6","padding-sm":"ElevatedBox_padding-sm__j9i3k","padding-none":"ElevatedBox_padding-none__UNMT2"};